import Vue from 'vue'
import Router from 'vue-router'
// import Details from '@/modules/AtomicChain/pages/Details'
// import newsDetails from '@/modules/AtomicChain/pages/newsDetails'
// import picList from '@/modules/AtomicChain/pages/picList'
// import picDetails from '@/modules/AtomicChain/pages/picDetails'
// import videoList from '@/modules/AtomicChain/pages/videoList'
// import teamMemberDetail from '@/modules/AtomicChain/pages/teamMemberDetail'
// import audiodetail from '@/modules/AtomicChain/pages/audiodetail'
// import audioList from '@/modules/AtomicChain/pages/audioList'
// import infos from '@/modules/AtomicChain/pages/infos'
// import videoPlayer from '@/modules/AtomicChain/pages/videoPlayer'
// import pdfCheck from '@/modules/AtomicChain/pages/pdf'

Vue.use(Router);
// let routes = [];
let routes = [
    // --------------------------------中文路由区----------------------------------------------------------------
    {
        path: '/',
        // redirect: '/AtomicChain/home', //跳转到首页
        name: 'DCHome',
        // component: resolve => require(['@/modules/AtomicChain/pages/home.vue'], resolve),
        component: () => import("@/page_ch/home.vue"),
        meta: {
            keepAlive: true,
            title:"原子链-原子恋-原子币-ATOS,给世界赋能"
        }
    },
    {
        path: '/videoPlayer',
        name: 'videoPlayer',
        component: () => import("@/page_ch/videoPlayer.vue"),
    },
    {
        path: '/details',
        name: 'details',
        component: () => import("@/page_ch/Details.vue"),
    },
    {
        path: '/newsDetails',
        name: 'newsDetails',
        component: () => import("@/page_ch/newsDetails.vue"),
    },
    {
        path: '/picList',
        name: 'picList',
        component: () => import("@/page_ch/picList.vue"),
    },
    {
        path: '/picDetails',
        name: 'picDetails',
        component: () => import("@/page_ch/picDetails.vue"),
    },
    {
        path: '/videoList',
        name: 'videoList',
        component: () => import("@/page_ch/videoList.vue"),
    },
    {
        path: '/teamMemberDetail',
        name: 'teamMemberDetail',
        component: () => import("@/page_ch/teamMemberDetail.vue"),
    },
    {
        path: '/audiodetail',
        name: 'audiodetail',
        component: () => import("@/page_ch/audiodetail.vue"),
    },
    {
        path: '/audioList',
        name: 'audioList',
        component: () => import("@/page_ch/audioList.vue"),
    },
    {
        path: '/infos',
        name: 'infos',
        meta: {
            title: "关于原子链"
        },
        component: () => import("@/page_ch/infos.vue"),
    },
    {
        path: '/pdfCheck',
        name: 'pdfCheck',
        meta: {
            title: "白皮书"
        },
        component: () => import("@/page_ch/pdf.vue"),
    },
    {
        path: '/personalIntroduction',
        name: 'personalIntroduction',
        meta: {
            title: "CEO廖望简介"
        },
        component: () => import("@/page_ch/personalIntroduction.vue"),
    },
    {
        path: '/videoListPlayer',
        name: 'videoListPlayer',
        component: () => import("@/page_ch/videoListPlayer.vue"),
    },
    {
        path: '/youtubeplayers',
        name: 'youtubeplayers',
        component: () => import("@/page_ch/youtubePlayers.vue"),
    },

    // --------------------------------英文路由区----------------------------------------------------------------
    {
        path: '/en',
        // redirect: '/AtomicChain/home', //跳转到首页
        name: 'DCHome',
        // component: resolve => require(['@/modules/AtomicChain/pages/home.vue'], resolve),
        component: () => import("@/page_en/home.vue"),
        meta: {
            keepAlive: true,
            title:"ATOSHI"
        }
    },
    {
        path: '/downLoaden',
        name: 'downLoad',
        component: () => import("@/page_en/downLoad.vue"),
    },
    {
        path: '/detailsen',
        name: 'details',
        component: () => import("@/page_en/Details.vue"),
    },
    {
        path: '/newsDetailsen',
        name: 'newsDetails',
        component: () => import("@/page_en/newsDetails.vue"),
    },
    {
        path: '/picListen',
        name: 'picList',
        component: () => import("@/page_en/picList.vue"),
    },
    {
        path: '/picDetailsen',
        name: 'picDetails',
        component: () => import("@/page_en/picDetails.vue"),
    },
    {
        path: '/videoListen',
        name: 'videoList',
        component: () => import("@/page_en/videoList.vue"),
    },
    {
        path: '/teamMemberDetailen',
        name: 'teamMemberDetail',
        component: () => import("@/page_en/teamMemberDetail.vue"),
    },
    {
        path: '/audiodetailen',
        name: 'audiodetail',
        component: () => import("@/page_en/audiodetail.vue"),
    },
    {
        path: '/audioListen',
        name: 'audioList',
        component: () => import("@/page_en/audioList.vue"),
    },
    {
        path: '/pdfChecken',
        name: 'pdfCheck',
        meta: {
            title: "White Paper"
        },
        component: () => import("@/page_en/pdf.vue"),
    },
    {
        path: '/youtubeplayersen',
        name: 'youtubeplayersen',
        component: () => import("@/page_en/youtubePlayers.vue"),
    },


    {
        path: '/vpShare',
        name: 'vpShare',
        component: () => import("@/page_ch/vpShare.vue"),
    },


]
// let routes_en = [
//     {
//         path: '/',
//         // redirect: '/AtomicChain/home', //跳转到首页
//         name: 'DCHome',
//         // component: resolve => require(['@/modules/AtomicChain/pages/home.vue'], resolve),
//         component: () => import("@/page_en/home.vue"),
//         meta: {
//             keepAlive: true,
//         }
//     },
//     {
//         path: '/downLoaden',
//         name: 'downLoad',
//         component: () => import("@/page_en/downLoad.vue"),
//     },
//     {
//         path: '/detailsen',
//         name: 'details',
//         component: () => import("@/page_en/Details.vue"),
//     },
//     {
//         path: '/newsDetailsen',
//         name: 'newsDetails',
//         component: () => import("@/page_en/newsDetails.vue"),
//     },
//     {
//         path: '/picListen',
//         name: 'picList',
//         component: () => import("@/page_en/picList.vue"),
//     },
//     {
//         path: '/picDetailsen',
//         name: 'picDetails',
//         component: () => import("@/page_en/picDetails.vue"),
//     },
//     {
//         path: '/videoListen',
//         name: 'videoList',
//         component: () => import("@/page_en/videoList.vue"),
//     },
//     {
//         path: '/teamMemberDetailen',
//         name: 'teamMemberDetail',
//         component: () => import("@/page_en/teamMemberDetail.vue"),
//     },
//     {
//         path: '/audiodetailen',
//         name: 'audiodetail',
//         component: () => import("@/page_en/audiodetail.vue"),
//     },
//     {
//         path: '/audioListen',
//         name: 'audioList',
//         component: () => import("@/page_en/audioList.vue"),
//     },
//     {
//         path: '/pdfChecken',
//         name: 'pdfCheck',
//         meta: {
//             title: "White Paper"
//         },
//         component: () => import("@/page_en/pdf.vue"),
//     },
// ]
// console.log(sessionStorage.getItem("routeLanguage"),window.location.hash.substring(17))
// // 根据不同传参 展示不同语言效果
// if(window.location.hash.substring(17) == "zh" || window.location.hash.substring(17) == "en")
// {
//     if(window.location.hash.substring(17) == "zh")
//     {
//         routes = routes_ch;
//         sessionStorage.setItem("routeLanguage", "zh");
//     }
//     if(window.location.hash.substring(17) == "en")
//     {
//         routes = routes_en;
//         sessionStorage.setItem("routeLanguage", "en");

//     }
// }
// else
// if(sessionStorage.getItem("routeLanguage"))
// {
//     if(sessionStorage.getItem("routeLanguage") == "zh")
//     {
//         routes = routes_ch;
//         document.title = "原子链-原子恋-原子币-ATOS,给世界赋能"
//     }
//     if(sessionStorage.getItem("routeLanguage") == "en")
//     {
//         routes = routes_en;
//         document.title = "ATOSHI";
//     }
// }
// else
// {
//     routes = routes_ch;
//     sessionStorage.setItem("routeLanguage", "zh");
// }
// console.log(routes)
export default new Router({
    // mode: 'history',  //去掉url中的#
    routes: [
        ...routes,
        // ...AtomicChain,
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js